import React from 'react';
import styles from './style.module.css'

const BreadCrumb = (props) => (
	<div className={styles.wrapper}>
		<h1>{props.title}</h1>
	</div>
)
export default BreadCrumb;